
  import createMeisterIcons from '../src/createMeisterIcons';

  const SquareB = createMeisterIcons("square-b", [["path",{"fill":"currentColor","d":"M21 3H3v18h18z","key":"a19412f82906f356bfe74b5bc39a7d5f74da0ac1","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M2.25 2.25h19.5v19.5H2.25zm1.5 1.5v16.5h16.5V3.75z","key":"df7de21fb506895e47c9f4ef600d47a9595bb712","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default SquareB
  